var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small"},[_c('scatter',{attrs:{"chart-data":_vm.datacollection,"chart-options":_vm.options}}),_c('button',{on:{"click":function($event){return _vm.fillData()}}},[_vm._v("Randomize")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }